
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0692 10.4038C10.0692 10.4038 10.0692 8.95374 9.36273 8.87933C8.65629 8.80493 6.46262 8.87933 6.46262 8.87933V4.41761H9.73451C9.73451 4.41761 9.69734 2.93035 9.06524 2.93035H3.74834L4.64067 0.550781C4.64067 0.550781 3.30213 0.625186 2.8188 1.4803C2.33546 2.33542 0.811029 6.61132 0.811029 6.61132C0.811029 6.61132 1.33158 6.83441 2.18671 6.20235C3.04189 5.5703 3.33931 4.4548 3.33931 4.4548L4.90091 4.3804L4.93808 8.9165C4.93808 8.9165 2.22391 8.87933 1.66619 8.9165C1.10847 8.95368 0.811009 10.441 0.811009 10.441H4.93814C4.93814 10.441 4.56628 12.9693 3.52527 14.7912C2.44698 16.613 0.439209 18.0631 0.439209 18.0631C0.439209 18.0631 1.88926 18.658 3.3022 17.84C4.71507 16.9848 5.75617 13.3039 5.75617 13.3039L9.06532 17.431C9.06532 17.431 9.36275 15.4604 9.02815 14.9027C8.65629 14.345 6.72288 12.1141 6.72288 12.1141L5.8677 12.8577L6.4626 10.4037H10.0691L10.0692 10.4038ZM10.9244 2.81885L10.8872 16.2412H12.2257L12.7091 17.9144L15.0515 16.2412H18.3607V2.81885H10.9244H10.9244ZM15.3117 14.754H16.8733V4.34325H12.486V14.754H12.8949L13.3411 16.2784L15.3117 14.754Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Zhihu',
    }) as DefineComponent
    </script>
    